/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import { SET_PASTE_BUFFER } from "constants/ActionTypes";
import { SetPasteBufferAction } from "types/Actions";
import { ClipCopy } from "types/Clip";

export interface PasteBufferState {
  clips: ClipCopy[];
}

export default function PasteBufferReducer(
  state: PasteBufferState,
  action: SetPasteBufferAction
): PasteBufferState {
  switch (action.type) {
    case SET_PASTE_BUFFER:
      return { clips: action.clips };
    default:
      return state;
  }
}
